import { useEffect, useState } from 'react';
import axios from 'axios';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import PlanetLinks from '../../../components/PlanetLinks/PlanetLinks';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './PlanetPosition.scss';
import city from '../../../city.json'


const PlanetPosition = () => {
  const [planetData, setPlanetData] = useState([]);
  const [location, setLocation] = useState("Kolkata");
  const [currentDate, setCurrentDate] = useState(new Date());

  // Temporary states for user input for submit button and location dropdown
  const [tempDate, setTempDate] = useState(currentDate);
  const [tempLocation, setTempLocation] = useState("Kolkata");


  const [tempTime, setTempTime] = useState( //  new state for manual time input
    `${String(currentDate.getHours()).padStart(2, "0")}:${String(
      currentDate.getMinutes()
    ).padStart(2, "0")}`
  );


  const [suggestions, setSuggestions] = useState([]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  useEffect(() => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1;
    const day = currentDate.getDate();
    const hour = currentDate.getHours();
    const minute = currentDate.getMinutes();

    const fetchPlanetPositions = async () => {
      if (!location || location.trim() === '') return;
      try {
        const res = await axios.get(
          `https://core-c343.onrender.com/api/daily-planet-position?year=${year}&month=${month}&day=${day}&hour=${hour}&minute=${minute}&location=${encodeURIComponent(location)}`
        );
        setPlanetData(res.data.result || []);
      } catch (error) {
        console.error('Failed to fetch planet positions', error);
      }
    };

    const debounce = setTimeout(fetchPlanetPositions, 500);
    return () => clearTimeout(debounce);
  }, [currentDate, location]); // <-- dependency array updated

  const formattedDate = currentDate.toISOString().split("T")[0];

  const handlePrevDay = () => {
    const prev = new Date(currentDate);
    prev.setDate(prev.getDate() - 1);
    setCurrentDate(prev);
  };

  const handleNextDay = () => {
    const next = new Date(currentDate);
    next.setDate(next.getDate() + 1);
    setCurrentDate(next);
  };

  const handleDateInput = (e) => {
    setTempDate(new Date(e.target.value));
  };

  const handleMonthClick = (monthIndex) => {
    const newDate = new Date(tempDate);
    newDate.setMonth(monthIndex);
    setTempDate(newDate);
  };

  const handleDayClick = (day) => {
    const newDate = new Date(tempDate);
    newDate.setDate(day);
    setTempDate(newDate);
  };

  //  New handler for manual time input
  const handleTimeInput = (e) => {
    setTempTime(e.target.value);
  };

  const handleSubmit = () => {
    //  merge selected date with manual time input
    const [hours, minutes] = tempTime.split(":").map(Number);
    const updatedDate = new Date(tempDate);
    updatedDate.setHours(hours);
    updatedDate.setMinutes(minutes);

    setCurrentDate(updatedDate);
    setLocation(tempLocation);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };

  return (
    <div className="planet-position-container">
      <InnerNav />
      <div className="planet-position-content">
        <Zodiac />

        <div className="controls">
          <div className="month-grid">
            {months.map((month, i) => (
              <button key={i} onClick={() => handleMonthClick(i)}>
                {month}
              </button>
            ))}
          </div>

          <div className="day-grid">
            {Array.from({ length: 31 }, (_, i) => (
              <button key={i} onClick={() => handleDayClick(i + 1)}>
                {i + 1}
              </button>
            ))}
          </div>

          <div className="location-date">
            <div className="input-with-icon">
              <span className="icon">📍</span>
              <input
                type="text"
                value={tempLocation}
                onChange={handleChange}
                placeholder="Enter location"
              />
              {suggestions.length > 0 && (
                <ul className="dropdown">
                  {suggestions.map((c, idx) => (
                    <li key={idx} onClick={() => handleSelect(c.city)}>
                      {c.city}, {c.state}, {c.country}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <input
              type="date"
              value={tempDate.toISOString().split("T")[0]}
              onChange={handleDateInput}
            />

            {/*  New time input field */}
            <div className="time">
            <input
              type="time"
              value={tempTime}
              onChange={handleTimeInput}
            />
            </div>

            <button onClick={handlePrevDay}>Prev Day</button>
            <button onClick={handleNextDay}>Next Day</button>
            <button onClick={handleSubmit}>Submit</button>
          </div>
        </div>

        <div className="planet-table">
          <table>
            <thead>
              <tr>
                <th>Planet</th>
                <th>Full Degree</th>
                <th>Nakshatra</th>
                <th>Nakshatra Lord</th>
                <th>Padam</th>
                <th>Longitude</th>
              </tr>
            </thead>
            <tbody>
              {planetData.length > 0 ? (
                planetData.map((planet, index) => (
                  <tr key={index}>
                    <td>{planet.planet}</td>
                    <td>{planet.fullDegree}</td>
                    <td>{planet.nakshatra}</td>
                    <td>{planet.nakshatraLord}</td>
                    <td>{planet.padam}</td>
                    <td>{planet.longitude}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center' }}>
                    Loading planet positions...
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="planet-cards">
          {planetData.length > 0 ? (
            planetData.map((planet, index) => (
              <div className="planet-card" key={index}>
                <h3>{planet.planet}</h3>
                <p><strong>Full Degree:</strong> {planet.fullDegree}</p>
                <p><strong>Nakshatra:</strong> {planet.nakshatra}</p>
                <p><strong>Nakshatra Lord:</strong> {planet.nakshatraLord}</p>
                <p><strong>Padam:</strong> {planet.padam}</p>
                <p><strong>Longitude:</strong> {planet.longitude}</p>
              </div>
            ))
          ) : (
            <p>Loading planet cards...</p>
          )}
        </div>

        <PlanetLinks />
      </div>
      <Footer />
    </div>
  );
};

export default PlanetPosition;
